import { IdentifierDTO } from '@zazume/zzm-base';

import { doGet } from '../../helpers';

export interface TotalTenantAlertsDTO {
  totalAlerts: number;
  uniqueTenants: number;
  qualifiedTenants: number;
}

export interface UnitTenantAlertStatistics {
  unitId: IdentifierDTO;
  qualifiedTenants: number;
  uniqueTenants: number;
  nonAlertedTenants: number;
  qualifiedNonAlertedTenants: number;
  tenantsWithApplications: number;
  createdAt: Date;
  updatedAt: Date;
}

export const tenantAlert = {
  calculateUnitAlerts: (unitId: IdentifierDTO) => () =>
    doGet<TotalTenantAlertsDTO>(`/dashboard/tenant-alerts/calculate-unit-alerts/${unitId}`),
  findLastAlertUnitStatistics: (unitId: IdentifierDTO) => () =>
    doGet<UnitTenantAlertStatistics | null>(`/dashboard/tenant-alerts/last-unit-statistics/${unitId}`)
};
